import './Footer.css';

function Footer() {
  const currentYear = new Date().getFullYear();

  let footerMainDisplay = "flex"
  let footerBoxWidth = "50%"
  let footerRightDisplay = "flex"
  let footerRightJustifyContent = "flex-end"
  let footerRightMarginLeft = "0px"

  if(window.innerWidth < 767) {
    footerMainDisplay = "grid"
    footerBoxWidth = "80%"
    footerRightDisplay = "block"
    footerRightJustifyContent = "start"
    footerRightMarginLeft = "10%"
  }

  return (
    <div id="Footer">
      <div id="Footer-main" style={{display: footerMainDisplay}}>
        <div id="Footer-left" style={{width: footerBoxWidth}}>
          <div id="Footer-left-name">Herbert M. Potechius</div>
          <div className='Footer-left-text'>Berlin, Germany</div>
          {/* <div className='Footer-left-text'>/</div>
          <div className='Footer-left-text'>/</div>
          <div className='Footer-left-text'>/</div> */}
        </div> 
        <div id="Footer-right" style={{width: footerBoxWidth, 
                                       display: footerRightDisplay,
                                       justifyContent: footerRightJustifyContent,
                                       marginLeft: footerRightMarginLeft}}>
          <div id="Footer-right-textblock">
            <div id="Footer-left-name">Contact</div>
            <div className='Footer-left-text' style={{fontWeight:"bold"}}>Email</div>
            <div className='Footer-left-text'>herbert@potechius.com</div>
            {/* <div className='Footer-left-text' style={{fontWeight:"bold"}}>Phone</div>
            <div className='Footer-left-text'>+49 3641 205716</div> */}
          </div>
        </div>
      </div>
      <div id="Footer-copyright">© {currentYear} Herbert M. Potechius</div>
    </div>
  );
}

export default Footer;
